<p-toast></p-toast>
<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

<div class="expense-details-page p-fluid">
    <ng-container *ngIf="expense; else expenseState">
        <p-progressBar mode="indeterminate" class="page-progress" *ngIf="isLoading"></p-progressBar>


        <app-page-detail-hero [eyebrow]="'Expense ' + (expense?.expenseNumber || ('#' + expense?.expenseId))"
            [title]="expense?.description || 'Expense Details'" [subtitle]="getDetailSubtitle()"
            icon="pi pi-receipt" [auditStamp]="expense">
            <div tags class="page-toolbar-tags">
                <p-tag [value]="expense?.status || 'Draft'" [severity]="getStatusSeverity(expense?.status)"></p-tag>
                <p-tag [value]="expense?.currencyCode || 'SAR'" severity="info"></p-tag>
                <p-tag [value]="getClientDisplayName(expense)" severity="secondary"></p-tag>
                <p-tag [value]="(expense?.attachments?.length || 0) + ' attachments'" severity="success"></p-tag>
            </div>
            <div actions class="page-toolbar-actions">
                <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" routerLink="/expense"></p-button>
                <p-button *ngIf="canEditExpense && expense?.status === 'Draft'" label="Edit Expense" icon="pi pi-pencil" severity="info" (click)="editExpense()"></p-button>
                <p-button *ngIf="canCreateVoucher && expense?.status === 'Posted' && settlement && settlement.openAmount > 0"
                    label="Create Voucher" icon="pi pi-wallet" severity="success" (click)="openPaymentDialog()"></p-button>
                <p-button *ngIf="canShowApprovalAction('Approved')" label="Approve" icon="pi pi-check" severity="success" (click)="openApprovalDialog('Approved')"></p-button>
                <p-button *ngIf="canShowApprovalAction('Rejected')" label="Reject" icon="pi pi-times" severity="danger" [outlined]="true" (click)="openApprovalDialog('Rejected')"></p-button>
                <p-button label="New Expense" icon="pi pi-plus" routerLink="/expense/add"></p-button>
            </div>
        </app-page-detail-hero>

        <app-page-metric-strip [metrics]="getMetrics()"></app-page-metric-strip>

        <section class="expense-profile-panel" *ngIf="settlement">
            <div class="section-header">
                <div>
                    <h2>Payment settlement</h2>
                    <p>{{ settlement.payeeName }} ({{ settlement.payeeType }}) · {{ settlement.currencyCode }}</p>
                </div>
            </div>
            <div class="detail-list">
                <div><span>Paid</span><strong>{{ settlement.paidAmount | currency:settlement.currencyCode:'symbol':'1.2-2' }}</strong></div>
                <div><span>Open balance</span><strong>{{ settlement.openAmount | currency:settlement.currencyCode:'symbol':'1.2-2' }}</strong></div>
            </div>
            <p-table [value]="settlement.paymentVouchers" styleClass="p-datatable-sm" *ngIf="settlement.paymentVouchers.length">
                <ng-template pTemplate="header"><tr><th>Payment voucher</th><th>Amount</th><th>Allocation</th><th>Voucher status</th></tr></ng-template>
                <ng-template pTemplate="body" let-payment>
                    <tr>
                        <td><a [routerLink]="['/accounts/enterprise/payables/generated-vouchers/view', payment.voucherId]">{{ payment.voucherNumber }}</a></td>
                        <td>{{ payment.amount | currency:settlement.currencyCode:'symbol':'1.2-2' }}</td>
                        <td>{{ payment.allocationStatus }}</td><td>{{ payment.documentStatus }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </section>

        <div class="expense-detail-grid">
            <section class="expense-profile-panel">
                <div class="section-header">
                    <div>
                        <h2>Expense Profile</h2>
                        <p>Reference, company, submitter, and spend summary for this record.</p>
                    </div>
                </div>

                <div class="info-group">
                    <div class="group-heading"><i class="pi pi-file"></i><span>Overview</span></div>
                    <div class="detail-list">
                        <div><span>Expense #</span><strong>{{ expense?.expenseNumber || '-' }}</strong></div>
                        <div><span>Description</span><strong>{{ expense?.description || '-' }}</strong></div>
                        <div><span>Status</span><strong>{{ expense?.status || 'Draft' }}</strong></div>
                        <div><span>Expense Date</span><strong>{{ expense?.submissionDate | date:'mediumDate' }}</strong></div>
                    </div>
                </div>

                <div class="info-group">
                    <div class="group-heading"><i class="pi pi-users"></i><span>Parties</span></div>
                    <div class="detail-list">
                        <div><span>Submitted by</span><strong>{{ expense?.submittedBy?.name || '-' }}</strong></div>
                        <div><span>Commercial Party</span><strong>{{ getClientDisplayName(expense) }}</strong></div>
                        <div><span>Contact</span><strong>{{ getContactDisplayName(expense) }}</strong></div>
                        <div *ngIf="expense?.partyEntityType"><span>Party Type</span><strong>{{ expense?.partyEntityType }}</strong></div>
                        <div><span>Paid By</span><strong>{{ expense?.owningCompany?.name || '-' }}</strong></div>
                    </div>
                </div>

                <div class="info-group">
                    <div class="group-heading"><i class="pi pi-calculator"></i><span>Financials</span></div>
                    <div class="detail-list">
                        <div><span>Currency</span><strong>{{ expense?.currencyCode || 'SAR' }}</strong></div>
                        <div><span>Total</span><strong>{{ expense?.totalAmount | currency:(expense?.currencyCode || 'SAR'):'symbol':'1.2-2' }}</strong></div>
                        <div><span>Tax</span><strong>{{ getTotalTaxAmount(expense) | currency:(expense?.currencyCode || 'SAR'):'symbol':'1.2-2' }}</strong></div>
                        <div><span>Items</span><strong>{{ expense?.items?.length || 0 }}</strong></div>
                    </div>
                </div>


                <div class="info-group" *ngIf="expense?.notes">
                    <div class="group-heading"><i class="pi pi-comment"></i><span>Notes</span></div>
                    <p class="notes-text">{{ expense?.notes }}</p>
                </div>
            </section>

            <section class="expense-workspace-panel">
                <p-tabs [value]="activeTabIndex" (valueChange)="onTabChange($event)">
                    <p-tablist>
                        <p-tab [value]="0">
                            <div class="tab-label">
                                <i class="pi pi-list"></i>
                                <span>Items</span>
                            </div>
                        </p-tab>
                        <p-tab [value]="1">
                            <div class="tab-label">
                                <i class="pi pi-paperclip"></i>
                                <span>Attachments</span>
                            </div>
                        </p-tab>
                        <p-tab [value]="2">
                            <div class="tab-label">
                                <i class="pi pi-sitemap"></i>
                                <span>Approvals</span>
                            </div>
                        </p-tab>
                        <p-tab [value]="3">
                            <div class="tab-label">
                                <i class="pi pi-diagram-project"></i>
                                <span>Workflow</span>
                            </div>
                        </p-tab>
                    </p-tablist>

                    <p-tabpanels>
                        <p-tabpanel [value]="0">
                            <div class="workspace-header">
                                <div>
                                    <h2>Expense Items</h2>
                                    <p>{{ expense?.items?.length || 0 }} line items</p>
                                </div>
                            </div>

                            <p-table [value]="expense?.items || []" styleClass="p-datatable-sm expense-items-table">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Date</th>
                                        <th>Account</th>
                                        <th>Description</th>
                                        <th class="text-right">Amount</th>
                                        <th class="text-right">Tax</th>
                                        <th class="text-center">Reimb.</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>{{ item.itemDate | date:'mediumDate' }}</td>
                                        <td>{{ item.account?.accountName || '-' }}</td>
                                        <td>{{ item.description || '-' }}</td>
                                        <td class="text-right">{{ item.amount | currency:(expense?.currencyCode || 'SAR'):'symbol':'1.2-2' }}</td>
                                        <td class="text-right">{{ item.taxAmount | currency:(expense?.currencyCode || 'SAR'):'symbol':'1.2-2' }}</td>
                                        <td class="text-center">
                                            <i class="pi" [ngClass]="item.isReimbursable ? 'pi-check-circle reimbursable' : 'pi-times-circle non-reimbursable'"></i>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="6">
                                            <div class="empty-state compact">
                                                <i class="pi pi-list"></i>
                                                <strong>No expense items</strong>
                                                <span>Line-level accounting data has not been added yet.</span>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-tabpanel>

                        <p-tabpanel [value]="1">
                            <div class="workspace-header">
                                <div>
                                    <h2>Supporting Attachments</h2>
                                    <p>{{ expense?.attachments?.length || 0 }} files</p>
                                </div>
                            </div>

                            <p-fileUpload
                                *ngIf="canUploadAttachments"
                                #fileUploader
                                class="attachment-uploader"
                                [customUpload]="true"
                                [multiple]="true"
                                accept="image/*,application/pdf"
                                [maxFileSize]="2000000"
                                (uploadHandler)="onAttachmentsSelect($event)">
                                <ng-template pTemplate="empty">
                                    <div class="upload-empty-state">
                                        <i class="pi pi-cloud-upload"></i>
                                        <span>Upload receipt images or PDFs for this expense.</span>
                                    </div>
                                </ng-template>
                            </p-fileUpload>

                            <div class="attachment-list" *ngIf="expense?.attachments?.length; else noAttachments">
                                <article class="attachment-card" *ngFor="let attachment of expense?.attachments">
                                    <div class="attachment-main">
                                        <i class="pi pi-file attachment-icon"></i>
                                        <div class="attachment-copy">
                                            <strong>{{ attachment.fileName }}</strong>
                                            <span>{{ ((attachment.fileSize || 0) / 1024) | number:'1.0-0' }} KB</span>
                                        </div>
                                    </div>
                                    <div class="attachment-actions">
                                        <button pButton pRipple type="button" icon="pi pi-download" class="p-button-text p-button-secondary" (click)="downloadAttachment(attachment)"></button>
                                        <button *ngIf="canDeleteAttachments" pButton pRipple type="button" icon="pi pi-trash" class="p-button-text p-button-danger" (click)="confirmDeleteAttachment(attachment)"></button>
                                    </div>
                                </article>
                            </div>
                            <ng-template #noAttachments>
                                <div class="empty-state compact">
                                    <i class="pi pi-paperclip"></i>
                                    <strong>No attachments uploaded</strong>
                                    <span>Add receipts or supporting documents to complete the record.</span>
                                </div>
                            </ng-template>
                        </p-tabpanel>

                        <p-tabpanel [value]="2">
                            <div class="workspace-header">
                                <div>
                                    <h2>Approval Timeline</h2>
                                    <p>{{ expense?.approvals?.length || 0 }} approval steps</p>
                                </div>
                            </div>

                            <div *ngIf="expense?.approvals?.length; else noApprovals">
                                <p-timeline [value]="expense?.approvals || []" align="left" styleClass="customized-timeline">
                                    <ng-template pTemplate="marker" let-approval>
                                        <span class="timeline-marker" [ngClass]="getApprovalStatusClass(approval.status)">
                                            <i [ngClass]="getApprovalStatusIcon(approval.status)"></i>
                                        </span>
                                    </ng-template>
                                    <ng-template pTemplate="content" let-approval>
                                        <article class="timeline-card">
                                            <div class="timeline-top">
                                                <div>
                                                    <div class="timeline-title">{{ approval.approver?.name || 'Approver pending' }}</div>
                                                    <span>{{ approval.approvalDate ? (approval.approvalDate | date:'medium') : 'Awaiting response' }}</span>
                                                </div>
                                                <p-tag [value]="approval.status" [severity]="getApprovalTagSeverity(approval.status)"></p-tag>
                                            </div>
                                            <p *ngIf="approval.comments">{{ approval.comments }}</p>
                                            <p *ngIf="!approval.comments" class="timeline-empty">No comments recorded.</p>
                                        </article>
                                    </ng-template>
                                </p-timeline>
                            </div>
                            <ng-template #noApprovals>
                                <div class="empty-state compact">
                                    <i class="pi pi-sitemap"></i>
                                    <strong>No approvals started</strong>
                                    <span>This expense has not entered the approval workflow yet.</span>
                                </div>
                            </ng-template>
                        </p-tabpanel>

                        <p-tabpanel [value]="3">
                            <app-workflow-panel
                                *ngIf="expense?.expenseId && expense?.owningCompany?.id"
                                resourceKey="EXPENSE"
                                [resourceId]="expense?.expenseId!"
                                [companyId]="expense?.owningCompany?.id!"
                                [context]="workflowContext">
                            </app-workflow-panel>
                        </p-tabpanel>
                    </p-tabpanels>
                </p-tabs>
            </section>
        </div>
    </ng-container>
</div>

<p-dialog header="Create payment voucher" [(visible)]="paymentDialogVisible" [modal]="true" [style]="{ width: '36rem' }">
    <div class="payment-voucher-form" *ngIf="settlement">
        <p>Expense {{ settlement.expenseNumber }} · Open {{ settlement.openAmount | currency:settlement.currencyCode:'symbol':'1.2-2' }}</p>
        <div><strong>Payee</strong><span>{{ settlement.payeeName }} ({{ settlement.payeeType }})</span></div>
        <div><strong>Currency</strong><span>{{ settlement.currencyCode }}</span></div>
        <div><strong>AP account</strong><span>#{{ settlement.creditAccountId }}</span></div>
        <label for="expensePaymentAmount">Payment amount</label>
        <input id="expensePaymentAmount" type="number" min="0.01" step="0.01" [max]="settlement.openAmount" [(ngModel)]="paymentAmount" />
        <label for="expensePaymentMode">Payment method</label>
        <select id="expensePaymentMode" [(ngModel)]="paymentMode">
            <option value="CASH">Cash</option><option value="BANK_TRANSFER">Bank transfer</option><option value="CHEQUE">Cheque</option>
        </select>
        <ng-container *ngIf="paymentMode === 'CASH'; else bankAccountSelector">
            <label for="expenseCashAccount">Cash account</label>
            <select id="expenseCashAccount" [(ngModel)]="cashAccountId">
                <option [ngValue]="undefined">Select cash account</option>
                <option *ngFor="let account of cashAccounts" [ngValue]="account.accountId">{{ account.accountCode }} · {{ account.accountName }}</option>
            </select>
        </ng-container>
        <ng-template #bankAccountSelector>
            <label for="expenseBankAccount">Company bank account</label>
            <select id="expenseBankAccount" [(ngModel)]="fromBankAccountId">
                <option [ngValue]="undefined">Select bank account</option>
                <option *ngFor="let account of companyBankAccounts" [ngValue]="account.id">{{ account.accountName }} · {{ account.accountNumber }}</option>
            </select>
        </ng-template>
        <small>The voucher is saved as a draft. Submit, approve, and post it from the voucher page.</small>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" severity="secondary" [outlined]="true" (click)="paymentDialogVisible = false"></p-button>
        <p-button label="Save draft voucher" icon="pi pi-save" [loading]="paymentSaving" (click)="savePaymentVoucher()"></p-button>
    </ng-template>
</p-dialog>

<ng-template #expenseState>
    <div class="loading-state" *ngIf="isLoading; else notFound">
        <i class="pi pi-spin pi-spinner"></i>
        <p>Loading expense details...</p>
    </div>
    <ng-template #notFound>
        <div class="empty-state permission-state">
            <i class="pi pi-wallet"></i>
            <strong>Expense not found</strong>
            <span>The requested expense could not be loaded.</span>
        </div>
    </ng-template>
</ng-template>

<p-dialog [(visible)]="displayApprovalDialog" [modal]="true" [style]="{ width: '32rem' }" [header]="currentAction === 'Approved' ? 'Approve Expense' : 'Reject Expense'">
    <div class="approval-dialog">
        <label for="approvalComments" class="font-medium">Comments</label>
        <textarea id="approvalComments" pInputTextarea rows="4" [(ngModel)]="approvalComments" class="w-full" placeholder="Add approval notes or rejection context"></textarea>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" [text]="true" (onClick)="displayApprovalDialog = false"></p-button>
        <p-button [label]="currentAction === 'Approved' ? 'Approve' : 'Reject'" [icon]="currentAction === 'Approved' ? 'pi pi-check' : 'pi pi-times'" [severity]="currentAction === 'Approved' ? 'success' : 'danger'" (onClick)="confirmApprovalAction()"></p-button>
    </ng-template>
</p-dialog>
